import { Action, ActionReducer, MemoizedSelector } from '@ngrx/store';
import { createVideoActions, VideoActions } from './actions';
import { VideoState, createVideoReducer, initialState } from './reducer';
import { createVideoSelectors, VideoSelectors } from './selectors';
import { StateAdapter } from 'src/app/ngrx-helpers/adapters/types';

export interface VideoAdapter
  extends StateAdapter<
    VideoActions,
    VideoSelectors,
    ActionReducer<VideoState, Action>,
    VideoState
  > {}

export function createVideoAdapter(options: {
  stateKeyOrSelector: string | MemoizedSelector<object, VideoState>;
  type: string;
}): VideoAdapter {
  const { type, stateKeyOrSelector } = options;

  const actions = createVideoActions(type);
  const reducer = createVideoReducer(actions);
  const selectors = createVideoSelectors(stateKeyOrSelector);

  return {
    getActions: () => actions,
    getSelectors: () => selectors,
    getReducer: () => reducer,
    getInitialState: () => initialState,
  };
}
